import { useQuery } from 'react-query'
import { listPackages } from '@lib/axios/package'
import { useMemo } from 'react'
import useQueryString from '@hooks/useQueryString'

function useIndex() {
  const { params } = useQueryString()
  const { status, data } = useQuery(
    ['saas-package', params],
    () => listPackages(params),
    {
      retry: false,
      staleTime: Infinity,
      keepPreviousData: true,
    }
  )

  // prettier-ignore
  const tableData = useMemo(
    () => (status === 'success' && Array.isArray(data?.data?.data)
      ? data?.data?.data
      : []),
    [status, data]
  )

  const emptyPagination = useMemo(
    () => ({
      current_page: 1,
      first_page: true,
      last_page: false,
      next_page: null,
      prev_page: null,
      total_pages: 1,
    }),
    []
  )

  // prettier-ignore
  const tablePagination = useMemo(
    () => (status === 'success' && data?.data?.pagination
      ? data?.data?.pagination
      : emptyPagination),
    [status, data, emptyPagination]
  )

  const columns = [
    ['id', 'ID', true],
    ['name', 'Nama Paket', false],
    ['price', 'Harga', true],
    ['affiliate_commission', 'Komisi Affiliate', true],
    ['trial_time', 'Waktu Trial', true],
    ['status', 'Status', true],
    ['created_at', 'created_at ', true],
    ['updated_at', 'updated_at', true],
  ]

  const tableColumns = columns
    .map(([column, title]) => [column, title])
    .map(([accessor, Header]) => ({ accessor, Header }))

  const hiddenColumns = columns
    .filter(([, , hidden]) => hidden)
    .map(([column]) => column)

  return {
    tableData,
    tableColumns,
    hiddenColumns,
    tablePagination,
  }
}

export default useIndex
